import { useEffect, useState } from "react";
import { getClippingConfigDocumentURL, getClippingConfigSectionURL} from "../../utils/ConstantsURL";

export const useUserClippingConfig = (userId, token, refresh) => {
  const [loading, setLoading] = useState(true);
  const [configDocs, setConfigDocs] = useState([]);
  const [configSections, setConfigSections] = useState([]);

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const [resDocs, resSections] = await Promise.all([
          fetch(getClippingConfigDocumentURL(userId), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
          fetch(getClippingConfigSectionURL(userId), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

        const dataDocs = await resDocs.json();
        const dataSections = await resSections.json();

        setConfigDocs(Array.isArray(dataDocs) ? dataDocs : []);
        setConfigSections(Array.isArray(dataSections) ? dataSections : []);
      } catch (error) {
        console.error("Error fetching config data:", error);
        setConfigDocs([]);
        setConfigSections([]);
      } finally {
        setLoading(false);
      }
    };

    if (userId && token) {
      fetchConfigs();
    }
  }, [userId, token, refresh]);

  return { loading, configDocs, configSections };
};
